import React from 'react';
import parse from 'html-react-parser';
import {
  DisclosuresWrapper,
  DisclosureWithSymbol
} from '@ecs/tng-common/components/disclosures/Disclosures';
import FontIconCardsSlider from '@ecs/tng-common/components/cards-slider/FontIconCardsSlider';
import {
  ficoShort,
  scoreBoostResults,
  savingsNegotiationShort,
  debitCardCFSB,
  registeredMark,
  ficoSymbolAlt
} from '@ecs/tng-common/documents/disclosures/regulatory';
import { scrollTo, ifMobile } from '@ecs/tng-common/scripts/helpers';
import {
  IActionCardsContent,
  IActionDisclosures,
  IFeatureActionCard
} from '../content/action-cards';

type ActionCardsProps = {
  catId: number;
  content: IActionCardsContent;
  className?: string;
  heading: string;
};

export default class ActionCardsSlider extends React.Component<ActionCardsProps> {
  render() {
    const { content, heading, catId } = this.props;
    const disclosures: IActionDisclosures[] = [];
    const update = (card: IFeatureActionCard) => {
      if (card && card.disclosure && !disclosures.includes(card.disclosure)) {
        disclosures.push(card.disclosure);
      }
      if (card.dataLink) {
        return { ...card, dataLink: card.dataLink + catId };
      }
      return card;
    };
    const updateContent = (cards: IFeatureActionCard[]) => {
      const updatedCards = cards.map((card) => {
        return update(card);
      });
      return updatedCards;
    };

    const cards = updateContent(content.regular);
    const featured = update(content.featured);

    const returnDisclosure = (disclosure: IActionDisclosures, key: string) => {
      switch (disclosure) {
        case 'fico':
          return (
            <DisclosureWithSymbol
              key={`${key}-actions-disclosure`}
              disclosure={ficoShort}
              symbol={ficoSymbolAlt}
              id={'fico-d-action'}
            />
          );
        case 'boost':
          return (
            <DisclosureWithSymbol
              key={`${key}-actions-disclosure`}
              disclosure={scoreBoostResults}
              id="score-boost-d-action"
            />
          );
        case 'sm':
          return (
            <p key={`${key}-actions-disclosure`}>
              {parse(
                `${debitCardCFSB} Experian Boost${registeredMark} results will vary. <a href="/help/experian-smart-money/">See disclosures</a>.`
              )}
            </p>
          );
        case 'subscriptions':
          return (
            <DisclosureWithSymbol
              key={`${key}-actions-disclosure`}
              disclosure={savingsNegotiationShort}
              id="savings-negotiation-d-action"
            />
          );
        default:
          return null;
      }
    };
    return (
      <section
        className={`${this.props.className || ''} container container-py`}
        id="action-cards">
        <h2 className="content-mb">{parse(heading)}</h2>
        <FontIconCardsSlider
          featured={featured}
          cards={cards}
          cardsPerSlide={6}
          sliderSettings={{
            afterChange: () => {
              if (ifMobile()) {
                scrollTo('action-cards');
              }
            }
          }}
        />
        {disclosures.length > 0 ? (
          <DisclosuresWrapper className="disclosures-mt">
            {disclosures.map((disclosure, index: number) => {
              return returnDisclosure(disclosure, `${index}-act-disclos`);
            })}
          </DisclosuresWrapper>
        ) : null}
      </section>
    );
  }
}
